import React from 'react';
import { Star } from 'lucide-react';
// Renders 4 full stars + 1 half star (4.5 rating), no empty/background stars
const HalfStarRow = ({
  color = '#FFB900'
}: {
  color?: string;
}) => {
  const size = 16;
  return <div className="flex gap-0.5 items-center" data-id="element-18">
      {[...Array(4)].map((_, i) => <Star key={`full-${i}`} size={size} fill={color} color={color} strokeWidth={0} data-id="element-19" />)}
      {/* Half star: filled left half only, no right half outline */}
      <div className="relative" style={{
      width: size,
      height: size
    }} data-id="element-20">
        <div className="absolute top-0 left-0 overflow-hidden" style={{
        width: size / 2,
        height: size
      }} data-id="element-21">
          <Star size={size} fill={color} color={color} strokeWidth={0} data-id="element-22" />
        </div>
      </div>
    </div>;
};
const RatingRow = ({
  rating,
  color = '#FFB900'
}: {
  rating: string;
  color?: string;
}) => <div className="flex items-center gap-2 my-1" data-id="element-23">
    <HalfStarRow color={color} data-id="element-24" />
    <span className="text-sm font-semibold text-gray-800" data-id="element-25">{rating}</span>
  </div>;
export function TrustBadges() {
  return <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 w-full mt-8 pt-4" data-id="element-26">
      {/* Google */}
      <div className="flex flex-col items-center" data-id="element-27">
        <div className="text-2xl font-medium tracking-tighter mb-1 select-none" data-id="element-28">
          <span className="text-[#4285F4]" data-id="element-29">G</span>
          <span className="text-[#EA4335]" data-id="element-30">o</span>
          <span className="text-[#FBBC05]" data-id="element-31">o</span>
          <span className="text-[#4285F4]" data-id="element-32">g</span>
          <span className="text-[#34A853]" data-id="element-33">l</span>
          <span className="text-[#EA4335]" data-id="element-34">e</span>
        </div>
        <RatingRow rating="4.8" data-id="element-35" />
        <span className="text-[11px] text-gray-600 font-medium mt-1" data-id="element-36">
          Based On 22,000+ Reviews
        </span>
      </div>

      {/* ConsumerAffairs */}
      <div className="flex flex-col items-center" data-id="element-37">
        <div className="text-[22px] font-bold tracking-tight mb-1 text-black select-none" data-id="element-38">
          Consumer<span className="font-serif font-black" data-id="element-39">Affairs</span>
        </div>
        <RatingRow rating="4.6" data-id="element-40" />
        <span className="text-[11px] text-gray-600 font-medium mt-1" data-id="element-41">
          Based On 18,500+ Reviews
        </span>
      </div>

      {/* Trustpilot */}
      <div className="flex flex-col items-center" data-id="element-42">
        <div className="flex items-center gap-1.5 mb-1 select-none" data-id="element-43">
          <div className="bg-[#00B67A] p-0.5 rounded-sm" data-id="element-44">
            <Star size={18} fill="white" color="white" data-id="element-45" />
          </div>
          <span className="text-[22px] font-bold tracking-tight text-black" data-id="element-46">
            Trustpilot
          </span>
        </div>
        <RatingRow rating="4.9" color="#00B67A" data-id="element-47" />
        <span className="text-[11px] text-gray-600 font-medium mt-1" data-id="element-48">
          Based On 31,000+ Reviews
        </span>
      </div>
    </div>;
}